import {gql} from "@apollo/client";
import {UsersByMixedDataType} from "../../schema";

export type QueryData = {
  mixed: UsersByMixedDataType;
};

export const usersQuery = gql`
  query UserSelectComponentQuery(
    $usersIds: [ID!]
    $groupsIds: [ID!]
    $excludeGroupsIds: [ID!]
    $plainText: String
    $challengeIds: [ID!]
  ) {
    mixed: getUsersByMixedData(
      usersIds: $usersIds
      groupsIds: $groupsIds
      excludeGroupsIds: $excludeGroupsIds
      plainText: $plainText
      challengeIds: $challengeIds
    ) {
      users {
        id
        fullName
        name
        email
        failReasons
        groups {
          id
          name
        }
        challenges {
          id
          name
          alreadyAssigned
          activateAt
          deactivateAt
          projectName
        }
      }
      emails
    }
  }
`;
